<template>
    <button @click="$emit('action')" :class="{ 'isWhite': colorMode === 'white' }">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.14286 0H16.7143C17.4244 0 18 0.575634 18 1.28571V12.8571C18 13.5672 17.4244 14.1429 16.7143 14.1429C16.0042 14.1429 15.4286 13.5672 15.4286 12.8571V4.3897L2.19485 17.6234C1.69275 18.1255 0.87868 18.1255 0.376577 17.6234C-0.125526 17.1213 -0.125526 16.3073 0.376577 15.8051L13.6103 2.57143H5.14286C4.43278 2.57143 3.85714 1.99579 3.85714 1.28571C3.85714 0.575634 4.43278 0 5.14286 0Z" />
        </svg>
    </button>
</template>

<script>
export default {
    name: 'botonSpecial',
    data() {
        return {
        }
    },
    props: {
        colorMode: {
            type: String,
            default: 'default'
        }
    }
}
</script>

<style scoped>
.isWhite {
    border: .069444vw solid #ffffff;

}

.isWhite:hover {
    background: linear-gradient(90deg, #B359F8 0%, #B359F8 20%, #96FF11 40%, #FFE711 60%, #4536EF 80%, #FF00B8 100%);
    background-position: 0% 0%;
    background-size: 500%;
}

button {
    display: flex;
    min-width: 2.777778vw;
    min-height: 2.777778vw;
    align-items: center;
    justify-content: center;
    gap: .694444vw;
    border: .069444vw solid #979797;
    border-radius: 34.722222vw;
    transition: all 300ms ease;

    animation: hoverMiniOut 2s;


}

.isWhite svg {
    fill: #fff;
}

button svg {
    width: .833333vw;
    height: .833333vw;
    fill: #B359F8;
    transition: transform 400ms 1.3s ease, fill 400ms 0s ease;
    transform: rotate(0deg);

}

button:hover {
    background: linear-gradient(90deg, #fff 0%, #fff 20%, #96FF11 40%, #FFE711 60%, #4536EF 80%, #FF00B8 100%);
    background-position: 0% 0%;
    background-size: 500%;
    animation: hoverMini 2s 1 both;
    border: .069444vw solid #97979700;
}




button:hover svg {
    /* animation: hoverMiniIcon 2s ease 1 both; */
    transform: rotate(45deg);
    fill: #fff;


}

@keyframes hoverMiniIcon {
    0% {
        transform: rotate(0deg);

    }

    25% {
        transform: rotate(0deg);
        fill: #ffffff;

    }

    65% {
        transform: rotate(0deg);
        fill: #ffffff;

    }

    100% {
        transform: rotate(45deg);
        fill: #ffffff;

    }
}

@keyframes hoverMini {
    0% {
        background-position: 1% 0%;
    }

    35% {
        background-position: 45% 0%;
    }

    65% {
        background-position: 45% 0%;
    }

    100% {
        background-position: 99% 0%;
    }
}

@keyframes hoverMiniIconOut {

    0% {
        transform: rotate(45deg);
        fill: #ffffff;

    }

    100% {
        transform: rotate(0deg);

    }


}

@keyframes hoverMiniOut {
    0% {
        background-position: 99% 0%;
    }

    100% {
        background-position: 1% 0%;
    }
}

@media (max-width: 530px) {
    button {
        height: 9.302326vw;
        width: 9.302326vw;
    }

    button svg {
        height: 2.325581vw;
        width: 2.325581vw;
    }
}
</style>